var _style, _circle, _g, _circle2, _g2, _g3, _circle3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptionRedC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 269.3 269.3",
    style: {
      enableBackground: "new 0 0 269.3 269.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.4;fill:url(#SVGID_00000100369044324233508100000005868052671479244674_);}\n\t.st2{fill:url(#SVGID_00000126294080657163479980000006223843454111732911_);}\n\t.st3{opacity:0.16;}\n\t.st4{opacity:0.5;fill:#FFFFFF;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\n\t.st6{opacity:0.5;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:url(#SVGID_00000057106736505455053360000009537563692694444932_);}\n\t.st9{opacity:0.4;fill:url(#SVGID_00000142139024528927262210000010454913185801113278_);}\n\t.st10{fill:url(#SVGID_00000145034565307199698480000012648418422385843897_);}\n\t.st11{opacity:0.5;fill:#020202;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1122.7441,
    y1: 3343.7612,
    x2: 1122.7441,
    y2: 3600.7295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5440B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#252E5E"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1122.7,
    cy: 3472.2,
    r: 128.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048492756703924468870000011408380530619074194_",
    gradientUnits: "userSpaceOnUse",
    x1: 1104.3657,
    y1: 3409.8088,
    x2: 1104.3657,
    y2: 3586.3008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2D2F9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    style: {
      stopColor: "#5A6BC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#2D2F9D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000048492756703924468870000011408380530619074194_)"
    },
    d: "M1130.7,3579 c-64.2,0-116.2-52-116.2-116.2c0-19.1,4.6-37.1,12.8-53c-11.8,17.9-18.6,39.4-18.6,62.4c0,63,51.1,114.1,114.1,114.1 c29.8,0,57-11.5,77.3-30.2C1180.7,3570.5,1156.7,3579,1130.7,3579z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183946096532727448130000013717353948686066824_",
    gradientUnits: "userSpaceOnUse",
    x1: 1122.7441,
    y1: 3343.7612,
    x2: 1122.7441,
    y2: 3600.7295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007340605,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.0037435
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183946096532727448130000013717353948686066824_)"
    },
    d: "M1122.7,3343.8 c-71,0-128.5,57.5-128.5,128.5c0,71,57.5,128.5,128.5,128.5c71,0,128.5-57.5,128.5-128.5 C1251.2,3401.3,1193.7,3343.8,1122.7,3343.8z M1122.7,3596.5c-68.6,0-124.2-55.6-124.2-124.2c0-68.6,55.6-124.2,124.2-124.2 c68.6,0,124.2,55.6,124.2,124.2C1247,3540.8,1191.3,3596.5,1122.7,3596.5z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1174.5,
    cy: 3370.4,
    r: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1188.8,3374.5c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8 C1187.5,3371.6,1188.8,3372.9,1188.8,3374.5z"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 1122.7,
    cy: 3472.2,
    r: 131.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 698,
    height: 768,
    xlinkHref: "9EBA85BB.png",
    transform: "matrix(0.24 0 0 0.24 1039.0526 3382.6526)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1075.1,3413.7h52.1c12.8,0,22.9,3.5,29.3,9.9c5.1,5.1,7.7,11.4,7.7,19.1v0.3c0,12.7-6.7,19.7-14.7,24.2 c13,5,21,12.5,21,27.6v0.3c0,20.5-16.7,30.8-42,30.8h-53.4V3413.7z M1121.9,3459c10.9,0,17.8-3.5,17.8-11.9v-0.3 c0-7.4-5.8-11.5-16.2-11.5h-24.4v23.7H1121.9z M1128.4,3504.2c10.9,0,17.5-3.8,17.5-12.2v-0.3c0-7.5-5.6-12.2-18.3-12.2h-28.5 v24.7H1128.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109029045406003808800000017786397769346108083_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.6457,
    y1: 6.1615,
    x2: 134.6457,
    y2: 263.1298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F70E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#DF724E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000109029045406003808800000017786397769346108083_)"
    },
    cx: 134.6,
    cy: 134.6,
    r: 128.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108286387066899223210000016634871977070193536_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.2673,
    y1: 72.2091,
    x2: 116.2673,
    y2: 248.7011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F70E00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01747918,
    style: {
      stopColor: "#F4190C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07088383,
    style: {
      stopColor: "#EE352D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1287,
    style: {
      stopColor: "#E84C48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1917,
    style: {
      stopColor: "#E45E5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2622,
    style: {
      stopColor: "#E16B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3465,
    style: {
      stopColor: "#E07373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    style: {
      stopColor: "#DF7576"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6255,
    style: {
      stopColor: "#E07373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7143,
    style: {
      stopColor: "#E16B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7881,
    style: {
      stopColor: "#E45F5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8537,
    style: {
      stopColor: "#E84D48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9138,
    style: {
      stopColor: "#EE362D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9692,
    style: {
      stopColor: "#F41A0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    style: {
      stopColor: "#F70E00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000108286387066899223210000016634871977070193536_)"
    },
    d: "M142.6,241.4 c-64.2,0-116.2-52-116.2-116.2c0-19.1,4.6-37.1,12.8-53c-11.8,17.9-18.6,39.4-18.6,62.4c0,63,51.1,114.1,114.1,114.1 c29.8,0,57-11.5,77.3-30.2C192.6,232.9,168.6,241.4,142.6,241.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177450085641275561800000015891685782587650208_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.6457,
    y1: 6.1615,
    x2: 134.6457,
    y2: 263.1298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007340605,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.0037435
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177450085641275561800000015891685782587650208_)"
    },
    d: "M134.6,6.2C63.7,6.2,6.2,63.7,6.2,134.6 s57.5,128.5,128.5,128.5s128.5-57.5,128.5-128.5S205.6,6.2,134.6,6.2z M134.6,258.9c-68.6,0-124.2-55.6-124.2-124.2 S66,10.4,134.6,10.4S258.9,66,258.9,134.6S203.2,258.9,134.6,258.9z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 186.4,
    cy: 32.8,
    r: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M200.7,36.9c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8c0-1.6,1.3-2.8,2.8-2.8 C199.4,34,200.7,35.3,200.7,36.9z"
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 134.6,
    cy: 134.6,
    r: 131.6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M78.9,137.5v-0.3c0-31.9,24-58,58.5-58c21.2,0,33.8,7.1,44.2,17.3l-15.7,18.1c-8.7-7.9-17.5-12.7-28.7-12.7 c-18.9,0-32.5,15.7-32.5,34.9v0.3c0,19.2,13.3,35.3,32.5,35.3c12.8,0,20.7-5.1,29.5-13.1l15.7,15.9c-11.5,12.3-24.4,20-46,20 C103.4,195.2,78.9,169.7,78.9,137.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.9,132.5v-0.3c0-31.9,24-58,58.5-58c21.2,0,33.8,7.1,44.2,17.3l-15.7,18.1c-8.7-7.9-17.5-12.7-28.7-12.7 c-18.9,0-32.5,15.7-32.5,34.9v0.3c0,19.2,13.3,35.3,32.5,35.3c12.8,0,20.7-5.1,29.5-13.1l15.7,15.9c-11.5,12.3-24.4,20-46,20 C103.4,190.2,78.9,164.7,78.9,132.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionRedC);
export default __webpack_public_path__ + "static/media/option-red-c.8fe45910b9d5d4173aa62db7b2551c50.svg";
export { ForwardRef as ReactComponent };